import React from "react";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

export default function StickyMobileCTA() {
  return (
    <div
      data-testid="sticky-mobile-cta"
      className="fixed bottom-0 left-0 right-0 p-3 bg-white/90 backdrop-blur-xl border-t border-indigo-950/10 z-[50] lg:hidden"
    >
      <Button
        data-testid="sticky-cta-button"
        className="w-full rounded-full bg-rose-500 hover:bg-rose-600 text-white font-bold py-5 shadow-lg shadow-rose-500/20 transition-all group text-sm"
        onClick={() => document.getElementById("hero")?.scrollIntoView({ behavior: "smooth" })}
      >
        Create My Child's Book — Rs.499
        <ArrowRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" />
      </Button>
    </div>
  );
}
